module.exports = __webpack_public_path__ + "media/images/icons/arrow-back-circle-outline-9146d9b25d19c6e5a332a8e16430c02a.svg";